import { Injectable, OnDestroy } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PrimeDarkModeService implements OnDestroy {
  private observer?: MutationObserver;

  initialize(): void {
    if (typeof document === 'undefined') {
      return;
    }

    this.attachObserver();
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }

  private attachObserver(): void {
    const setup = () => {
      const body = document.body;
      if (!body) {
        return;
      }

      this.syncPrimeDarkClass(body);

      this.observer?.disconnect();
      this.observer = new MutationObserver(() => this.syncPrimeDarkClass(body));
      this.observer.observe(body, {
        attributes: true,
        attributeFilter: ['class', 'data-bs-theme'],
      });
    };

    if (document.body) {
      setup();
      return;
    }

    window.addEventListener('DOMContentLoaded', setup, { once: true });
  }

  private syncPrimeDarkClass(body: HTMLElement): void {
    const themeAttribute = body.getAttribute('data-bs-theme');
    const isDark =
      themeAttribute === 'dark' ||
      body.classList.contains('lpx-theme-dark') ||
      body.classList.contains('lpx-theme-dim');

    document.documentElement.classList.toggle('prime-dark', isDark);
  }
}
